import { useColor } from '../../../../../../modules/contexts/Color/useColor';
import theme from '../../../../../../theme';

export const useStatusStyles = () => {
  const { getHexByNome } = useColor();

  const verde = getHexByNome('Status BG - Verde', '#1E7E34');
  const vermelho = getHexByNome('Status BG - Vermelho', '#DC3545');
  const amarelo = getHexByNome('Status BG - Amarelo', '#FFC107');
  const cinza = getHexByNome('Status BG - Cinza', '#6C757D');

  const getStatusDistribuicaoStyle = (statusDistribuicao?: number) => {
    const status = Number(statusDistribuicao) === 1;

    return {
      backgroundColor: status ? theme.colors.azulgov : theme.colors.cinzaEscuro,
      color: status ? 'white' : 'white',
    };
  };

  const getStatusBinStyle = (value?: number) => {
    const status = Number(value) === 1;

    return {
      backgroundColor: status ? verde : vermelho,
    };
  };

  const getStatusRenameStyle = (value?: number) => {
    const status = Number(value);

    const bgColor =
      status === 1
        ? amarelo
        : status === 2
          ? verde
          : status === 3
            ? vermelho
            : status === 4
              ? cinza
              : 'white';

    return {
      backgroundColor: bgColor,
    };
  };

  return {
    getStatusDistribuicaoStyle,
    getStatusBinStyle,
    getStatusRenameStyle,
  };
};
